import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

import "./style.css";

const pad = (n) => String(n).padStart(2, '0');

const formatTime = (s, withHour) => {
    if (withHour) {
        return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }
    return pad(Math.floor(s / 60)) + ':' + pad(s % 60);
};

const svgProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
};

const IconWarn = ({ size = 28 }) => (
    <svg {...svgProps} width={size} height={size}>
        <path d="M12 5v9" />
        <circle cx="12" cy="19" r="1" fill="currentColor" />
    </svg>
);

const IconClock = ({ size = 28 }) => (
    <svg {...svgProps} width={size} height={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
    </svg>
);

const IconCheck = ({ size = 28 }) => (
    <svg {...svgProps} width={size} height={size}>
        <path d="M5 12.5l4.5 4.5L19 7.5" />
    </svg>
);

const IconLock = ({ size = 28 }) => (
    <svg {...svgProps} width={size} height={size}>
        <rect x="5" y="11" width="14" height="9" rx="2" />
        <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
);

const CONTENT = {
    warning: {
        Icon: IconWarn,
        title: 'Terlalu banyak percobaan login',
        text: 'Username atau password salah beberapa kali. Jika percobaan berikutnya gagal, akun Anda akan masuk ke mode cooldown.',
    },
    cooldown: {
        Icon: IconClock,
        title: 'Terlalu banyak percobaan login',
        text: 'Silakan tunggu beberapa detik.',
        label: 'Cooldown',
    },
    block: {
        Icon: IconLock,
        title: 'Akun Anda diblokir',
        text: 'Akun Anda telah diblokir sementara untuk keamanan.',
        label: 'Waktu blokir',
    },
    done: {
        Icon: IconCheck,
        title: 'Silakan login kembali',
        text: 'Waktu cooldown telah selesai. Anda dapat mencoba login kembali.',
    },
};

function LoginPopup({ type, endAt, onClose, onFinish }) {
    const hitungSisa = () => Math.max(0, Math.ceil((endAt - Date.now()) / 1000));
    const [left, setLeft] = useState(endAt ? hitungSisa() : 0);

    useEffect(() => {
        if (!endAt) return;
        setLeft(hitungSisa());
        const timer = setInterval(() => {
            const sisa = hitungSisa();
            setLeft(sisa);
            if (sisa <= 0) {
                clearInterval(timer);
                if (onFinish) onFinish();
            }
        }, 250);
        return () => clearInterval(timer);
    }, [endAt]); // eslint-disable-line react-hooks/exhaustive-deps

    const c = CONTENT[type];
    if (!c) return null;

    const Icon = c.Icon;
    const isTimer = type === 'cooldown' || type === 'block';

    return createPortal(
        <div className="lp-overlay" role="dialog" aria-modal="true">
            <div className={'lp-card lp-' + type}>
                <button type="button" className="lp-x" onClick={onClose} aria-label="Tutup">&times;</button>

                <div className="lp-icon"><Icon /></div>
                <h6 className="lp-title">{c.title}</h6>
                <p className="lp-text">{c.text}</p>

                {isTimer ? (
                    <div className="lp-timer">
                        <Icon size={30} />
                        <div className="lp-timer-text">
                            <span>{c.label}</span>
                            <strong>{formatTime(left, type === 'block')}</strong>
                        </div>
                    </div>
                ) : null}

                {type !== 'cooldown' ? (
                    <button type="button" className="lp-btn" onClick={onClose}>Tutup</button>
                ) : null}
            </div>
        </div>,
        document.body
    );
}

export default LoginPopup;